import React from "react";
import styled from "styled-components";
import { componentTypeInfo } from "./utils";
import VariableTable from "./VariableTable";
import ComponentTable from "./ComponentTable";

type Value = PluginConfigItem | ScriptConfigItem;

interface Props<T extends Value> {
  value: T;
  onChange: (value: T) => void;
}

const ComponentTitle = styled.span`
  font-size: 14px;
  margin-left: 10px;
`;

const PluginScriptNav = <T extends Value>(props: Props<T>) => {
  const { value, onChange } = props;

  return (
    <div>
      <ComponentTable value={value} onChange={onChange} />
      <VariableTable
        title={
          value.type === "iconik_plugin_config"
            ? "Plugin Variables"
            : "Script Variables"
        }
        value={value.variables}
        onChange={(variables) => {
          onChange({
            ...value,
            variables,
          });
        }}
      />
      {value.type === "iconik_plugin_config" &&
        value.components
          .filter(
            ({ type }) =>
              type === "custom_action_config" ||
              type === "metadata_view_config" ||
              type === "list_input_config"
          )
          .map((comp) => {
            const component = comp as CustomActionConfig | MetadataViewConfig;
            const { title } = componentTypeInfo(component.type);
            return (
              <VariableTable
                key={component.id}
                title={
                  <>
                    <span>
                      {component.type === "custom_action_config"
                        ? "Metadata"
                        : "Variables"}
                    </span>
                    <ComponentTitle>
                      {component.title || "Unnamed " + title}
                    </ComponentTitle>
                  </>
                }
                value={component.variables}
                onChange={(variables) => {
                  onChange({
                    ...value,
                    components: value.components.map((c) =>
                      c.id === component.id
                        ? {
                            ...c,
                            variables,
                          }
                        : c
                    ),
                  });
                }}
              />
            );
          })}
    </div>
  );
};

export default PluginScriptNav;
